// extracted by mini-css-extract-plugin
export var textInput = "_gx-0";